module.exports = __webpack_public_path__ + "img/pc_p2_minwu.601bc46b.png";